export function sectionNameId(sectionId: string): string {
  return `section-${sectionId}-name`;
}

export function sectionTableId(sectionId: string): string {
  return `section-${sectionId}-table`;
}
